// Bridge to the existing company switch (App.vue listens to `changeCompany`).
// Switching re-creates Header and this module's component, so the pending switch
// lives here, outside any component instance, until the new instance picks it up.

import { eventBus } from '@eventBus'

// No explicit failure event exists; if the new session is not applied in time, give up.
const SWITCH_TIMEOUT_MS = 20000

let intent = null
let timer = null
let sequence = 0
let onFail = null

function stopWaiting() {
    clearTimeout(timer)
    timer = null
    eventBus.$off('companyisChanget', handleApplied)
    eventBus.$off('globalLogout', cancelSwitch)
}

function expire() {
    const failed = intent
    const notify = onFail
    stopWaiting()
    intent = null
    onFail = null
    if (failed && notify) notify(failed)
}

// App.vue emits this after the new auth headers are applied; the profile refresh
// and the remount follow, and the new component takes the intent over.
function handleApplied() {
    if (!intent) return
    intent.applied = true
    eventBus.$off('companyisChanget', handleApplied)
    clearTimeout(timer)
    timer = setTimeout(expire, SWITCH_TIMEOUT_MS)
}

export function isSwitching() {
    return intent !== null
}

export function startSwitch(company, failCallback) {
    if (intent) return null
    intent = {
        id: ++sequence,
        companyId: company.key,
        profileId: company.switchTarget.profile_id !== undefined ? String(company.switchTarget.profile_id) : null,
        name: company.name,
        applied: false,
    }
    onFail = failCallback
    eventBus.$on('companyisChanget', handleApplied)
    eventBus.$on('globalLogout', cancelSwitch)
    timer = setTimeout(expire, SWITCH_TIMEOUT_MS)
    eventBus.$emit('changeCompany', company.switchTarget)
    return intent
}

// Called by a freshly mounted component; returns the switch only once and only after it was applied.
export function takeAppliedSwitch() {
    if (!intent || !intent.applied) return null
    const taken = intent
    stopWaiting()
    intent = null
    onFail = null
    return taken
}

export function detachFailCallback(callback) {
    if (onFail === callback) onFail = null
}

function cancelSwitch() {
    stopWaiting()
    intent = null
    onFail = null
}
